import { timeToMinutes } from './reservation-time';

export interface IShiftHours {
  days: readonly number[];
  from: string;
  to: string;
}

export function shiftsOverlap(a: IShiftHours, b: IShiftHours): boolean {
  const ranges = (shift: IShiftHours) =>
    shift.days.map((day) => {
      const from = timeToMinutes(shift.from);
      const to = timeToMinutes(shift.to);
      return {
        start: day * 1440 + from,
        end: day * 1440 + to + (to < from ? 1440 : 0),
      };
    });
  return ranges(a).some((left) =>
    ranges(b).some((right) =>
      [-10080, 0, 10080].some(
        (offset) =>
          left.start < right.end + offset && right.start + offset < left.end
      )
    )
  );
}

export function findOverlappingShiftPair(
  shifts: readonly IShiftHours[]
): [number, number] | null {
  for (let first = 0; first < shifts.length; first++)
    for (let second = first + 1; second < shifts.length; second++)
      if (shiftsOverlap(shifts[first], shifts[second])) return [first, second];
  return null;
}
